module.exports = __webpack_public_path__ + "images/3a9da3f9768d10338c28da4cb9c53214-IMG_0241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_0241.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_0241.jpg
// module chunks = 0